import gql from 'graphql-tag';
import { useQuery, provideApolloClient } from '@vue/apollo-composable';
import { ref, watch } from 'vue';
import useDecryptSymbols from './useDecryptSymbols';
import useAlerts from '@/composables/useAlerts';
import apolloClient from './useApolloClient';

const { decryptSymbols } = useDecryptSymbols();
const { addAlert } = useAlerts();

const GET_USER = gql`
  query User($userid: ID!) {
    user(userid: $userid) {
      USERID
      FIRSTNAME
      LASTNAME
      EMAIL
      STARTPAGE
      LOCATION
      INSIDESALES
      OUTSIDESALES
      ADMIN
      LEADSADMIN
      CONTACTSADMIN
      SHOWLEADS
      SHOWIMPACTREPORT
      SHOWCONTACTS
      SHOWGENERALREPORTS
      OOO
      BACKINOFFICE
      ASSIGNLEADS
    }
  }
`;

export default function useUserQuery() {
  function getUser(userid) {
    provideApolloClient(apolloClient);

    const user = ref({});

    const { result, error, loading } = useQuery(GET_USER, { userid }, { fetchPolicy: 'no-cache' });

    watch(result, () => {
      const decrypted = decryptSymbols(result.value.user);
      user.value = decrypted;
    });

    watch(error, () => {
      if (error.value) {
        console.error('Error fetching user:', error.value);
        addAlert('Error fetching user', 'high', 4);
      }
    });

    return { loading, user, error };
  }

  return {
    getUser,
  };
}
